import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Check, Copy } from 'lucide-react'

/** Restaurant ID with a copy button, for super admins handling support and configuration. */
export function RestaurantIdCopy({ id }: { id: number }) {
  const { t } = useTranslation('restaurants')
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    // The ID stays visible as text if the browser blocks clipboard access.
    const ok = await navigator.clipboard.writeText(String(id)).then(() => true, () => false)
    if (!ok) return
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <span className="inline-flex items-center gap-1 text-sm text-muted-foreground">
      #{id}
      <button
        type="button"
        onClick={() => void copy()}
        className="rounded p-1 transition-colors hover:bg-muted hover:text-foreground"
        title={t('management.copyId')}
        aria-label={t('management.copyId')}
      >
        {copied ? <Check className="h-3 w-3 text-green-600" /> : <Copy className="h-3 w-3" />}
      </button>
    </span>
  )
}
